<template>
  <section class="accruals-hero" data-testid="accruals-page__hero">
    <div class="accruals-hero__backdrop" aria-hidden="true">
      <div class="accruals-hero__backdrop-glow accruals-hero__backdrop-glow--right" />
      <div class="accruals-hero__backdrop-glow accruals-hero__backdrop-glow--left" />
      <div class="accruals-hero__backdrop-card accruals-hero__backdrop-card--upper" />
      <div class="accruals-hero__backdrop-card accruals-hero__backdrop-card--lower" />
      <div class="accruals-hero__backdrop-fade" />
      <div class="accruals-hero__backdrop-inset" />
    </div>
    <div class="accruals-hero__content">
      <div class="accruals-hero__copy">
        <h2 class="accruals-hero__title">Set Up Your Accrual Estimates</h2>
        <p class="accruals-hero__description">
          Define rules and verify data. Once configured, Noa will be ready to automate your accrual estimates.
        </p>

        <div
          v-if="estimatesRunning"
          class="accruals-hero__progress-wrap"
          data-testid="accruals-page__hero-progress"
        >
          <base-button
            secondary
            small
            class="shadow-off accruals-hero__running-btn"
            disabled
            label="Running estimates..."
            data-testid="accruals-page__running-estimates-btn"
          />
          <div class="accruals-hero__progress-row">
            <div
              class="accruals-hero__progress-track"
              role="progressbar"
              :aria-valuenow="clampedProgress"
              aria-valuemin="0"
              aria-valuemax="100"
              :aria-label="`Estimates progress ${clampedProgress}%`"
            >
              <div
                class="accruals-hero__progress-fill"
                :style="{ width: `${clampedProgress}%` }"
              />
            </div>
            <span
              class="accruals-hero__progress-value"
              data-testid="accruals-page__hero-progress-value"
            >
              {{ clampedProgress }}%
            </span>
            <p class="accruals-hero__progress-hint">
              This may take a few minutes, check back later.
            </p>
          </div>
        </div>

        <v-tooltip
          v-else
          bottom
          :disabled="infoRequestConfigured"
          content-class="tooltip-bottom"
        >
          <template #activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              <base-button
                primary
                small
                class="shadow-off primaryBtn"
                :disabled="!infoRequestConfigured"
                data-testid="accruals-page__run-estimates-btn"
                @click="$emit('run-estimates')"
              >
                <span class="accruals-hero__cta-label">
                  Run estimates
                  <img
                    :src="ctaIcon"
                    alt=""
                    class="accruals-hero__cta-icon"
                    aria-hidden="true"
                  />
                </span>
              </base-button>
            </span>
          </template>
          <span>Set up an Info Request rule before running estimates.</span>
        </v-tooltip>
      </div>
      <div class="accruals-hero__illustration-wrap">
        <img
          :src="assets.HERO_ILLUSTRATION"
          alt=""
          class="accruals-hero__illustration"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { ACCRUALS_ASSETS } from '../accrualsPageConstants';

export default {
  name: 'AccrualsHeroBanner',
  props: {
    infoRequestConfigured: { type: Boolean, default: false },
    estimatesRunning: { type: Boolean, default: false },
    estimatesProgress: { type: Number, default: 0 },
  },
  data() {
    return {
      assets: ACCRUALS_ASSETS,
    };
  },
  computed: {
    ctaIcon() {
      return this.infoRequestConfigured
        ? this.assets.ARROW_RIGHT
        : this.assets.ARROW_RIGHT_MUTED;
    },
    clampedProgress() {
      const value = Number(this.estimatesProgress) || 0;
      return Math.min(100, Math.max(0, Math.round(value)));
    },
  },
};
</script>

<style lang="scss" scoped>
@import './AccrualsHeroBanner.scss';
</style>
